<template>
    <show-manual-pics
    :fileNames="['15.png']"/>
</template>

<script>
import showManualPics from '../components/modules/show-manual-pics.vue';
export default {
  components: { showManualPics },

}
</script>